module.exports = __webpack_public_path__ + "cert-notification.acab3f416bc8607edccf189ac63787dd.hashedasset.png";


//////////////////
// WEBPACK FOOTER
// ./app/img/layout/cert-notification.png
// module id = 1166059846975190
// module chunks = 1